import { useIsDesktop } from '@/_hooks/useBreakpoint';
import { CheckboxIcon } from '@/_assets/icon-components'
import { RadioCardItem, RadioCardRoot } from '@/components/ui/radio-card'
import { Box, HStack, Stack, StackSeparator } from '@chakra-ui/react'
import React from 'react'

const Sorted = ({
  options,
  value,
  onValueChange,
}: {
  value: string
  options: { id: string; label: string; value: string }[]
  onValueChange: (value: string | null) => void
}) => {
  const isDesktop = useIsDesktop()

  const handleLabelClick = (selectedValue: string) => {
    onValueChange(selectedValue)
  }
  return (
    <RadioCardRoot
      unstyled
      value={value}
      onValueChange={(e) => onValueChange(e?.value ?? '')}
    >
      <Stack
        separator={
          !isDesktop ? <StackSeparator borderColor='#0000000D' /> : undefined
        }
      >
        {options?.map((el) => (
          <HStack
            key={el.id}
            justifyContent={'space-between'}
            fontSize={{ base: 'sm', lg: 'md' }}
            onClick={() => handleLabelClick(el.value)}
          >
            <label htmlFor={el.id}>{el.label}</label>
            <RadioCardItem
              py={{ base: 3, lg: 2 }}
              icon={
                value === el.value ? (
                  <CheckboxIcon color={'var(--primary-default)'} />
                ) : (
                  <Box bg={'light.300'} w={7} h={7} rounded={'full'} />
                )
              }
              value={el.value}
              id={el.id}
              indicator={false}
              border={'none'}
            />
          </HStack>
        ))}
      </Stack>
    </RadioCardRoot>
  )
}

export default Sorted
